module.exports = __webpack_public_path__ + "img/equip_bracers.727a87f8.png";